const Articles = function () {
    let orderedLists = document.querySelectorAll('ol');
    let i = 1;

    orderedLists.forEach(ols => {
        let lists = ols.querySelectorAll('li');
        lists.forEach(list => {
            let number = document.createElement("p");
            list.insertAdjacentElement('afterbegin', number);
            number.innerHTML = '0' + i;
            i++;
        });
    });
}
    
export default Articles;